// import React, { useMemo, useState } from "react";
// import Modal from "../../Modal/Modal";
// import Button from "../../Buttons/Button";

// const DEFAULT_ORDER = [
//   "search",
//   "filter",
//   "download",
//   "viewToggle",
//   "add",
//   "fullScreen",
// ];

// const FullScreenWrapper = ({ children }) => {
//   const [isFullscreenOpen, setIsFullscreenOpen] = useState(false);

//   const child = React.Children.only(children);
//   const childToolbarRight = child.props?.toolbarRight;

//   const mergedToolbarRight = useMemo(() => {
//     const tr = childToolbarRight || {};

//     const existingAddComp = tr.add?.[0]?.component;
//     let existingChildren = [];

//     if (
//       React.isValidElement(existingAddComp) &&
//       existingAddComp.props?.children
//     ) {
//       existingChildren = React.Children.toArray(existingAddComp.props.children);
//     } else if (React.isValidElement(existingAddComp)) {
//       existingChildren = [existingAddComp];
//     }

//     const fullscreenIndex = existingChildren.length;

//     const fullscreenButton = (
//       <Button
//         icon={isFullscreenOpen ? "fullscreen_exit" : "fullscreen"}
//         title={isFullscreenOpen ? "Exit Fullscreen" : "Fullscreen"}
//         type="icon"
//         variant="text"
//         color="black"
//         onClick={() => setIsFullscreenOpen((s) => !s)}
//       />
//     );

//     const addWrapper = [
//       {
//         component: (
//           <>
//             {existingChildren}
//             {fullscreenButton}
//           </>
//         ),
//       },
//     ];

//     const baseOrder = Array.isArray(tr.order) ? tr.order : DEFAULT_ORDER;
//     const nextOrder = baseOrder.flatMap((k) => {
//       if (k === "add") {
//         return existingChildren.map((_, i) => `add[${i}]`);
//       }
//       if (k === "fullScreen") {
//         return [`add[${fullscreenIndex}]`];
//       }
//       return [k];
//     });

//     return {
//       ...tr,
//       fullScreen: false,
//       add: addWrapper,
//       order: nextOrder,
//     };
//   }, [childToolbarRight, isFullscreenOpen]);

//   const tableElement = useMemo(() => {
//     if (!React.isValidElement(child)) return null;
//     return React.cloneElement(child, { toolbarRight: mergedToolbarRight });
//   }, [child, mergedToolbarRight]);

//   return (
//     <>
//       {!isFullscreenOpen && tableElement}

//       <Modal
//         showCloseButton={false}
//         isOpen={isFullscreenOpen}
//         onClose={() => setIsFullscreenOpen(false)}
//         width="max-w-[100vw]"
//         wrapperClassName="p-0!"
//         panelClassName="!max-h-[100vh] h-[100dvh] rounded-none!"
//         bodyClassName="p-0! flex flex-1 overflow-hidden"
//         closeOnOutsideClick
//         zIndex={48}
//       >
//         <div className="w-full overflow-hidden flex flex-1 flex-col">
//           {tableElement}
//         </div>
//       </Modal>
//     </>
//   );
// };

// export default FullScreenWrapper;

import React, { useMemo, useState } from "react";
import Modal from "../../Modal/Modal";
import Button from "../../Buttons/Button";

const DEFAULT_ORDER = [
  "search",
  "filter",
  "download",
  "viewToggle",
  "add",
  "fullScreen",
];

const FullScreenWrapper = ({ children }) => {
  const [isFullscreenOpen, setIsFullscreenOpen] = useState(false);

  const child = React.Children.only(children);
  const childToolbarRight = child.props?.toolbarRight;

  const mergedToolbarRight = useMemo(() => {
    const tr = childToolbarRight || {};

    const existingAddComp = tr.add?.[0]?.component;
    let existingChildren = [];

    if (
      React.isValidElement(existingAddComp) &&
      existingAddComp.props?.children
    ) {
      existingChildren = React.Children.toArray(existingAddComp.props.children);
    } else if (React.isValidElement(existingAddComp)) {
      existingChildren = [existingAddComp];
    }

    const fullscreenIndex = existingChildren.length;

    const fullscreenButton = (
      <Button
        icon={isFullscreenOpen ? "fullscreen_exit" : "fullscreen"}
        title={isFullscreenOpen ? "Exit Fullscreen" : "Fullscreen"}
        type="icon"
        variant="text"
        color="black"
        onClick={() => setIsFullscreenOpen((s) => !s)}
      />
    );

    const addWrapper = [
      {
        component: (
          <>
            {existingChildren}
            {fullscreenButton}
          </>
        ),
      },
    ];

    const baseOrder = Array.isArray(tr.order) ? tr.order : DEFAULT_ORDER;
    const nextOrder = baseOrder.flatMap((k) => {
      if (k === "add") {
        return existingChildren.map((_, i) => `add[${i}]`);
      }
      if (k === "fullScreen") {
        return [`add[${fullscreenIndex}]`];
      }
      return [k];
    });

    return {
      ...tr,
      fullScreen: false,
      add: addWrapper,
      order: nextOrder,
    };
  }, [childToolbarRight, isFullscreenOpen]);

  const tableElement = useMemo(() => {
    if (!React.isValidElement(child)) return null;
    return React.cloneElement(child, { toolbarRight: mergedToolbarRight });
  }, [child, mergedToolbarRight]);

  return (
    <>
      {!isFullscreenOpen && tableElement}

      <Modal
        showCloseButton={false}
        isOpen={isFullscreenOpen}
        onClose={() => setIsFullscreenOpen(false)}
        width="max-w-[100vw]"
        wrapperClassName="p-0!"
        panelClassName="!max-h-[100vh] h-[100dvh] rounded-none!"
        bodyClassName="p-0! flex flex-1 overflow-hidden"
        closeOnOutsideClick
        zIndex={48}
      >
        <div className="w-full overflow-hidden flex flex-1 flex-col">
          {tableElement}
        </div>
      </Modal>
    </>
  );
};

export default FullScreenWrapper;
